import { Routes } from "@angular/router";
import { isAuthenticatedMatch, isNotAuthenticatedMatch } from "./auth/guards/is-authenticated.guard";
import { errorPageGuard } from "./core/guards/error-page.guard";
import { hasAppAccessGuard, isLaborConsultantGuard, isAdminOrHRGuard, featureGuard } from "./core/guards/authorization.guard";
import { FEATURE_KEYS } from "./core/constants/feature-keys";
import {
  accountDeactivatedRedirectGuard,
  accountDeactivatedPageGuard,
} from "./core/guards/account-deactivated.guard";
import { MainLayoutComponent } from "./core/layout/main-layout/main-layout.component";

export const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    canMatch: [isAuthenticatedMatch],
    canActivate: [accountDeactivatedRedirectGuard, hasAppAccessGuard],
    children: [
      {
        path: "",
        pathMatch: "full",
        loadComponent: () =>
          import("./core/components/landing/landing.component").then(
            (m) => m.LandingComponent,
          ),
      },
      {
        path: "employees",
        loadComponent: () =>
          import("./features/employees").then((m) => m.EmployeesComponent),
        data: { title: "Gestione Personale" },
      },
      {
        path: "employees/:cognitoSub",
        loadComponent: () =>
          import(
            "./features/employees/components/employee-detail/employee-detail.component"
          ).then((m) => m.EmployeeDetailComponent),
        data: { title: "Dettaglio Dipendente" },
      },
      {
        path: "leave-requests",
        loadComponent: () =>
          import("./features/leave-requests").then((m) => m.LeaveRequestsComponent),
        data: { title: "Presenze e Assenze" },
      },
      {
        path: "expense-reports",
        loadComponent: () =>
          import("./features/expense-reports").then((m) => m.ExpenseReportsComponent),
        data: { title: "Rimborsi Spese" },
      },
      {
        path: "payslips",
        canMatch: [featureGuard(FEATURE_KEYS.PAYSLIPS)],
        loadComponent: () =>
          import("./features/payslips").then((m) => m.PayslipsComponent),
        data: { title: "Cedolini" },
      },
      {
        path: "payslips/:id",
        canMatch: [featureGuard(FEATURE_KEYS.PAYSLIPS)],
        loadComponent: () =>
          import(
            "./features/payslips/components/payslip-detail/payslip-detail.component"
          ).then((m) => m.PayslipDetailComponent),
        data: { title: "Dettaglio Cedolino" },
      },
      {
        path: "documents",
        loadComponent: () =>
          import("./features/documents").then((m) => m.DocumentsComponent),
        data: { title: "Documenti" },
      },
      {
        path: "settings",
        loadComponent: () =>
          import("./features/settings").then((m) => m.SettingsComponent),
        data: { title: "Impostazioni" },
      },
      {
        path: "companies",
        loadComponent: () =>
          import("./features/companies").then((m) => m.CompaniesComponent),
        canActivate: [isLaborConsultantGuard],
        data: { title: "Gestione Aziende" },
      },
      {
        path: "bacheca",
        loadComponent: () =>
          import("./features/bacheca").then((m) => m.BachecaComponent),
        canActivate: [isAdminOrHRGuard],
        data: { title: "Bacheca" },
      },
    ],
  },
  {
    path: "",
    loadComponent: () =>
      import("./auth/auth.component").then((m) => m.AuthComponent),
    canMatch: [isNotAuthenticatedMatch],
  },
  {
    path: "access-denied",
    loadComponent: () =>
      import("./core/layout/access-denied-page/access-denied-page.component").then(
        (m) => m.AccessDeniedPageComponent
      ),
    canMatch: [isAuthenticatedMatch],
    data: { title: "Accesso Negato" },
  },
  {
    path: "error",
    loadComponent: () =>
      import("./core/layout/error-page/error-page.component").then(
        (m) => m.ErrorPageComponent
      ),
    canActivate: [errorPageGuard],
    data: { title: "Errore" },
  },
  {
    path: "account-deactivated",
    loadComponent: () =>
      import("./core/layout/account-deactivated/account-deactivated.component").then(
        (m) => m.AccountDeactivatedComponent
      ),
    canActivate: [accountDeactivatedPageGuard],
    data: { title: "Account disattivato" },
  },
  { path: "**", redirectTo: "" },
];
